/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTradingChallengeResultsOptions,
  GetTradingChallengeResultsStatus200,
  GetTradingChallengeResultsStatus400,
  GetTradingChallengeResultsStatus404,
  GetTradingChallengeResultsStatus500,
} from '../types/GetTradingChallengeResults'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTradingChallengeResults } from '../clients/getTradingChallengeResults'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTradingChallengeResultsQueryKey = ({
  path,
  query,
}: Omit<GetTradingChallengeResultsOptions, 'headers'>) =>
  [
    { url: '/v1/trading_challenges/:trading_challenge_id/results', params: path },
    ...(query ? [query] : []),
  ] as const

type GetTradingChallengeResultsQueryKey = ReturnType<typeof getTradingChallengeResultsQueryKey>

export function getTradingChallengeResultsQueryOptions(
  { path, query }: GetTradingChallengeResultsOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTradingChallengeResultsQueryKey({ path, query })
  return queryOptions<
    GetTradingChallengeResultsStatus200,
    ResponseErrorConfig<
      | GetTradingChallengeResultsStatus400
      | GetTradingChallengeResultsStatus404
      | GetTradingChallengeResultsStatus500
    >,
    GetTradingChallengeResultsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTradingChallengeResults({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description List challenge leaderboard/results. Public endpoint.
 * @summary Get trading challenge results
 * {@link /v1/trading_challenges/:trading_challenge_id/results}
 */
export function useGetTradingChallengeResults<
  TData = GetTradingChallengeResultsStatus200,
  TQueryData = GetTradingChallengeResultsStatus200,
  TQueryKey extends QueryKey = GetTradingChallengeResultsQueryKey,
>(
  {
    path,
    query,
  }: {
    path:
      | GetTradingChallengeResultsOptions['path']
      | (() => GetTradingChallengeResultsOptions['path'])
    query?:
      | GetTradingChallengeResultsOptions['query']
      | (() => GetTradingChallengeResultsOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTradingChallengeResultsStatus200,
        ResponseErrorConfig<
          | GetTradingChallengeResultsStatus400
          | GetTradingChallengeResultsStatus404
          | GetTradingChallengeResultsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey = resolvedOptions?.queryKey ?? getTradingChallengeResultsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTradingChallengeResultsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTradingChallengeResultsStatus400
      | GetTradingChallengeResultsStatus404
      | GetTradingChallengeResultsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
